import { all, takeEvery } from 'typed-redux-saga';
import { createReducer } from 'typesafe-actions';
import {
  afterCloseContextMenu,
  closeContextMenu,
  closeContextMenuSaga,
  handleAfterCloseContextMenu,
  handleCloseContextMenu,
} from './closeContextMenu';
import { handleShowContextMenu, showContextMenu } from './showContextMenu';
import { ContextMenuElem, ContextMenuState } from './types';

export { showContextMenu, closeContextMenu };

const initialState: ContextMenuState = {
  currentContextMenu: undefined,
};

export const reducer = createReducer(initialState)
  .handleAction(showContextMenu, handleShowContextMenu)
  .handleAction(closeContextMenu, handleCloseContextMenu)
  .handleAction(afterCloseContextMenu, handleAfterCloseContextMenu);

export function* watches(): Generator {
  yield all([takeEvery(closeContextMenu, closeContextMenuSaga)]);
}

export const contextMenuStateSelector = (state: any): ContextMenuState =>
  state.contextMenu;
export const currentContextMenuSelector = (
  state: any,
): ContextMenuElem | undefined =>
  contextMenuStateSelector(state).currentContextMenu;
